import SharedPreferences from "../../constants/SharedPreferences";
import {
  getErrorMessage,
  saveInStorage,
  getFromStorage,
  logApiResponse,
} from "../../util/Utility";
import BayunError from "../../constants/BayunError";
import Constants from "../../constants/Constants";
import { AuthenticateResponse } from "../../BayunCore";
import { registerUserApi } from "./developerApi";
import { setSecurityQuestionsPassphraseDialog } from "./internal/twoFaDialogUi";
import { createMemberData } from "./provisioningApi";
import { getTwoFAData } from "./twoFaApi";
export async function getMemberInfoForSSO(
  sessionId,
  bayunCore,
  orgMemberId,
  orgName,
  passcode,
  memberKeySalt,
  email,
  isOrgOwnedEmail,
  userStatus,
  appId,
  appKeyPairId,
  appSecret,
  loginFlow,
  memberAppStatus,
  multiFactorAuthentication,
  isAppCreatedWithPasscode,
  securityQuestionsCallback,
  passphraseCallback,
  authorizeMemberCallback,
  newUserCredentialsCallback,
  successCallback,
  failureCallback,
) {
  try {
    // if user status is IncompleteKeys, that means the user needs to create
    // security questions (and passphrase).
    await saveInStorage(
      sessionId,
      SharedPreferences.IS_VALIDATE_2FA_FOR_CREATE_MEMBER_APP,
      false,
    );
    await saveInStorage(
      sessionId,
      SharedPreferences.IS_VALIDATE_2FA_FOR_CREATE_MEMBER,
      false,
    );

    const memberCreationAppKeyPairId =
      (await getFromStorage(
        sessionId,
        SharedPreferences.MEMBER_CREATION_APP_KEY_PAIR_ID,
      ))

    if (loginFlow === Constants.LOGIN_FLOW_REGISTER) {
      if (memberAppStatus === Constants.MEMBER_APP_STATUS_UNLINKED) {
        // the member app is already created but the linking needs to be done from admin
        failureCallback(BayunError.ERROR_APP_NOT_LINKED);
      } else if (
        userStatus === null ||
        userStatus === "NotRegistered" ||
        userStatus === "IncompleteKeys"
      ) {
        await registerUserApi(
          sessionId,
          appId,
          memberCreationAppKeyPairId,
          appSecret,
          orgMemberId,
          orgName,
          email,
          isOrgOwnedEmail,
        );

        const enableFaceRecognition = await getFromStorage(
          sessionId,
          SharedPreferences.ENABLE_FACE_RECOGNITION,
        );

        if (memberAppStatus == Constants.MEMBER_APP_STATUS_NOT_EXISTS) {
          await saveInStorage(
            sessionId,
            SharedPreferences.IS_VALIDATE_2FA_FOR_CREATE_MEMBER_APP,
            true,
          );
        }

        // In register flow we are checking if newUserCredentialsCallback is not null then it means the user will give its own UI.
        if (newUserCredentialsCallback) {
          // return success with status to set SQ and passphrase
          newUserCredentialsCallback({
            sessionId,
            securityQuestions: null,
            authenticationResponse:
              AuthenticateResponse.SET_SECURITY_QUESTIONS_OR_PASSPHRASE,
          });
        } else {
          setSecurityQuestionsPassphraseDialog(
            bayunCore,
            sessionId,
            email,
            authorizeMemberCallback,
            successCallback,
            failureCallback,
            enableFaceRecognition,
          );
        }
      } else if (userStatus === "Registered") {
        if (
          isAppCreatedWithPasscode &&
          (multiFactorAuthentication ===
            Constants.MULTI_FACTOR_SINGLE_FA_WITH_PASSCODE ||
            multiFactorAuthentication ===
            Constants.MULTI_FACTOR_TWO_FACTOR_AUTHENTICATION_WITHOUT_PASSPHRASE ||
            multiFactorAuthentication ===
            Constants.MULTI_FACTOR_TWO_FACTOR_AUTHENTICATION_WITH_PASSPHRASE)
        ) {
          failureCallback(BayunError.ERROR_USER_PASSCODE_VERIFICATION_ENABLED);
          return;
        } else {
          if (
            memberAppStatus == Constants.MEMBER_APP_STATUS_NOT_EXISTS &&
            (await getFromStorage(sessionId, SharedPreferences.MEMBER_ID))
          ) {
            await saveInStorage(
              sessionId,
              SharedPreferences.IS_VALIDATE_2FA_FOR_CREATE_MEMBER_APP,
              true,
            );

            await authenticateUserWithoutPasscode(
              sessionId,
              bayunCore,
              appId,
              appKeyPairId,
              appSecret,
              orgMemberId,
              orgName,
              email,
              successCallback,
              failureCallback,
              securityQuestionsCallback,
              passphraseCallback,
              authorizeMemberCallback,
            );
            return;
          }

          if (
            (await getFromStorage(sessionId, SharedPreferences.MEMBER_ID)) ==
            null
          ) {
            console.log("Calling authenticateUserWithoutPasscode in show ui");

            await saveInStorage(
              sessionId,
              SharedPreferences.IS_VALIDATE_2FA_FOR_CREATE_MEMBER,
              true,
            );

            await authenticateUserWithoutPasscode(
              sessionId,
              bayunCore,
              appId,
              appKeyPairId,
              appSecret,
              orgMemberId,
              orgName,
              email,
              successCallback,
              failureCallback,
              securityQuestionsCallback,
              passphraseCallback,
              authorizeMemberCallback,
            );
          }
        }
      } else {
        console.log("Here we already have user 1");
        failureCallback(BayunError.ERROR_USER_ALREADY_EXISTS);
      }
    } else if (loginFlow === Constants.LOGIN_FLOW_LOGIN) {
      if (memberAppStatus === Constants.MEMBER_APP_STATUS_UNLINKED) {
        // the member app is already created but the linking needs to be done from admin
        failureCallback(BayunError.ERROR_APP_NOT_LINKED);
        return;
      }

      if (
        userStatus === "Registered" &&
        (await getFromStorage(sessionId, SharedPreferences.MEMBER_ID))
      ) {
        await authenticateUserWithoutPasscode(
          sessionId,
          bayunCore,
          appId,
          appKeyPairId,
          appSecret,
          orgMemberId,
          orgName,
          email,
          successCallback,
          failureCallback,
          securityQuestionsCallback,
          passphraseCallback,
          authorizeMemberCallback,
        );
      } else {
        //No call
        console.log("Failure call from sso");
        if (
          userStatus === "NotRegistered" &&
          loginFlow === Constants.LOGIN_FLOW_LOGIN
        ) {
          failureCallback(BayunError.ERROR_USER_IS_NOT_REGISTERED);
        } else if (
          userStatus === "PartiallyLinked" &&
          loginFlow === Constants.LOGIN_FLOW_LOGIN
        ) {
          failureCallback(BayunError.ERROR_LINK_USER_MEMBER_ON_ADMIN);
        } else {
          failureCallback(BayunError.ERROR_MEMBER_DOESNT_EXIST);
        }
      }
    }
  } catch (error) {
    console.log(error);
    console.log(error?.response?.data ?? error);
    failureCallback(getErrorMessage(sessionId, error?.response?.data ?? error));
  }
}

export async function authenticateUserWithoutPasscode(
  sessionId,
  bayunCore,
  appId,
  appKeyPairId,
  appSecret,
  orgMemberId,
  orgName,
  email,
  successCallback,
  failureCallback,
  securityQuestionsCallback,
  passphraseCallback,
  authorizeMemberCallback,
) {
  // create rest client
  // const restClient = getNonAuthRestClientForRegisterUser(appId, appKeyPairId);

  // call the authenticateSSOMember API
  // const authenticateSSOMemberResponse = await restClient.post(
  //   "/authenticateWithoutPasscode",
  //   {
  //     orgMemberId,
  //     orgName,
  //     email,
  //   }
  // );

  // await logApiResponse(
  //   "authenticateSSOMemberResponse",
  //   authenticateSSOMemberResponse
  // );


  // by pass this when already a user is there and just need to create a new member (exception case for source bayun_admin )
  if (process.env.SOURCE !== Constants.SOURCE.BAYUN_ADMIN) {
    // call the twoFAdata API
    await getTwoFAData(
      sessionId,
      bayunCore,
      appId,
      appSecret,
      null,
      successCallback,
      failureCallback,
      securityQuestionsCallback,
      passphraseCallback,
      authorizeMemberCallback,
    );
  } else {
    // by pass validations and call other apis directly
    await createMemberData(
      sessionId,
      orgName,
      orgMemberId,
      null,
      appId,
      appSecret,
      appKeyPairId,
      await getFromStorage(sessionId, SharedPreferences.GHOST_MEMBER_ID),
      await getFromStorage(sessionId, SharedPreferences.GHOST_MEMBER_SIGNING_PUBLIC_KEY_WITH_SIGNATURES),
      await getFromStorage(sessionId, SharedPreferences.ADMIN_PUBLIC_KEY),
      true,
      email,
      await getFromStorage(sessionId, SharedPreferences.USER_PRIVATE_KEY),
      authorizeMemberCallback,
      failureCallback,
    );

    successCallback({
      sessionId,
    });
  }
}
